import RecordSelector from "./RecordSelector";

interface ReferenceSelectorProps {
  name: string;
}

export default function ReferenceSelector({
  name,
}: ReferenceSelectorProps) {
  const formatOptionLabel = (option: any) => {
    return (
      <div>
        <div className="font-medium">{option.label}</div>
        {option.description && (
          <div className="text-sm text-gray-600">{option.description}</div>
        )}
      </div>
    )
  };

  return (
    <RecordSelector
      name={name}
      isMulti={false}
      searchUrl="/admin/reference/search"
      label="Reference"
      formatOptionLabel={formatOptionLabel}
      manageUrl="/admin/references"
      manageLabel="Manage or create references"
    />
  )
}
